export const upsellings = {
    text1: "Services",
    text2: "Gérez vos services",
    text3: "Liste des services",
    text4: "Fournisseurs",
    text5: "Liste des services que vos voyageurs verront",
    text6: "Enregistrer le service",
    text7: "Nom",
    text8: "Créé",
    text9: "État",
    text10: "actif",
    text11: "inactif",
    text12: "Modifier le service",
    text13: "Supprimer le service",
    text14: "Aucun service trouvé.",
    text15: "Modifié avec succès.",
    text16: "Voulez-vous vraiment supprimer le service",
    text17: "Vous perdrez vos données enregistrées",
    text18: "Supprimer le service",
    text19: "Annuler",
    text20: "Supprimé avec succès.",
    text21: "Créer un service",
    text22: "Informations du service",
    text23: "Saisissez les informations principales du service affichées sur la carte.",
    text24: "Tous les établissements",
    text25: "Sélectionner l'établissement *",
    text26: "Saisir le nom",
    text27: "Nom de votre service *",
    text28: "Automatique",
    text29: "Manuel",
    text30: "Type de confirmation",
    text31: "Titre du service",
    text32: "Saisir le titre *",
    text33: "Check-in/check-out",
    text34: "Transfert",
    text35: "F&B",
    text36: "Saisonnier",
    text37: "Famille",
    text38: "Romantique",
    text39: "SPA & Bien-être",
    text40: "Art & Culture",
    text41: "Activités",
    text42: "Services",
    text43: "Autres",
    text44: "Catégorie *",
    text45: "Service interne",
    text46: "Fournisseur *",
    text47: "Description",
    text48: "Saisissez la description de votre service *",
    text49: "Prix",
    text50: "Sélectionnez le type de prix et définissez le montant que vos voyageurs paieront pour l'offre.",
    text51: "Saisir le nombre",
    text52: "Par unité",
    text53: "Par personne",
    text54: "Par groupe",
    text55: "Par jour",
    text555: "Par heure",
    text56: "Prix par",
    text57: "Image",
    text58: "Téléchargez une image qui sera placée dans l'en-tête de la carte.",
    text59: "Enregistrer le service",
    text60: "Chargement ...",
    text61: "Service créé avec succès.",
    text62: "Liste des fournisseurs",
    text63: "Ajouter un fournisseur",
    text64: "ID",
    text65: "Nom",
    text66: "E-mail",
    text67: "Téléphone",
    text68: "Modifier le fournisseur",
    text69: "Supprimer le fournisseur",
    text70: "Enregistrer le fournisseur",
    text71: "Ajoutez des ",
    text72: "fournisseurs ",
    text73: "à votre liste afin de pouvoir les utiliser pour créer de nouvelles offres.",
    text74: "Saisir le nom",
    text75: "Nom du fournisseur *",
    text76: "Pays",
    text77: "Erreur",
    text78: "Saisissez votre numéro",
    text79: "Téléphone *",
    text80: "Adresse e-mail *",
    text81: "Adresse",
    text82: "Ajouter un fournisseur",
    text83: "Créé avec succès.",
    text84: "Voulez-vous vraiment supprimer le fournisseur ?",
    text85: "Vous perdrez vos données enregistrées",
    text86: "Supprimer le fournisseur",
    text87: "Supprimé avec succès.",
    text96: 'Gérez vos abonnements et factures',

    // Correcciones
    p1: "Prix sur demande",
};